import lightImg from 'assets/img/spot-illustrations/1.png';
import darkImg from 'assets/img/spot-illustrations/dark_1.png';
import { Link } from 'react-router-dom';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { signOut, getAuth } from 'firebase/auth';

const SignOutForm = () => {
  const auth = getAuth();
  signOut(auth);

  return (
    <div className="text-center mb-6 mx-auto">
      <img className="mb-7 d-dark-none" src={lightImg} alt="tomorrow" />
      <img className="mb-7 d-light-none" src={darkImg} alt="tomorrow" />
      <div className="mb-6">
        <h4 className="text-1000">로그아웃 완료</h4>
        <p className="text-700">
          Thanks for using tomorrow. <br className="d-lg-none" />
          You are now successfully signed out.
        </p>
      </div>
      <div className="d-grid">
        <Button
          variant="primary"
          as={Link}
          to={`/pages/auth/sign-in`}
          startIcon={<FontAwesomeIcon icon={faAngleLeft} className="me-2" />}
        >
          로그인 화면 이동
        </Button>
      </div>
    </div>
  );
};

export default SignOutForm;
